export default class operasionalModel {
    constructor({id,name, qty, icon, is_active, language, creataed_by, created_by_name, creates_on, updated_by, updated_by_name, updated_on}) {
        this.id = id;
        this.name = name;
        this.qty = qty;
        this.language = language;
        this.icon = icon;
        this.status = is_active;
        this.created_by = creataed_by;
        this.created_by_name = created_by_name;
        this.created_on = creates_on;
        this.updated_by = updated_by;
        this.updated_by_name = updated_by_name;
        this.updated_on = updated_on;
    }
}